import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { Filter } from './common.repository';
import { Product } from 'src/app/user/entites/product';

const COLLECTION_NAME = 'dynamic_category';

export type Category = {
    id?: string;
    title?: string;
    level?: number;
    subCategory?: Category[];
    codeCategory?: string;
    linkProduct?: any[];
    categoryLevelCategory?: number;
    nameCategory?: any;
    attachmentCategory?: any;
    subcategories?: Array<{ documentName: string; documentId: string; value: string }>;
    subcategoryList?: any;
    orderCategory?: number;
    categories?: Category[];
};

@Injectable()
export class CategoryRepository {
    constructor(private dynamicDocumentService: DynamicDocumentService) {}
    find(level = 1, page = 1, pageSize = 999): Observable<Category[]> {
        const filterCategories: Filter[] = [
            {
                fieldName: 'statusCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'VALIDE',
                    },
                ],
            },
            {
                fieldName: 'categoryLevelCategory',
                conditions: [...Array(level).keys()].map((level) => ({
                    type: 'EQUALS',
                    value: level + 1,
                })),
            },
        ];
        return this.dynamicDocumentService
            .find(
                {
                    collectionName: COLLECTION_NAME,
                    filters: filterCategories,
                    page: page,
                    pageSize: pageSize,
                    sorts: {
                        nameCategory: 'ASC',
                    },
                },
                true
            )
            .pipe(map((res) => this.transform(res.content)));
    }

    // -----------
    transform(categories: any[]) {
        let returnCategory: Category[] = [];

        // for (const category of categories) {
        //     returnCategory.set(category.codeCategory, {
        //         codeCategory: category.codeCategory,
        //         id: category.id,
        //         level: 1,
        //         title: category.nameCategory.fr_FR,
        //     });
        // }
        // for (const category of categories) {
        //     const codes = category.codeCategory.split('.');
        //     switch (category.categoryLevelCategory) {
        //         case 1:
        //             returnCategory.set(category.codeCategory, {
        //                 id: category.id,
        //                 level: 1,
        //                 title: category.nameCategory.fr_FR,
        //                 subCategory: new Map(),
        //                 codeCategory: category.codeCategory,
        //             });
        //             break;
        //         case 2:
        //             const parentCodeCategory = codes[0];
        //             if (!returnCategory.has(parentCodeCategory)) {
        //                 returnCategory.set(parentCodeCategory, { subCategory: new Map() });
        //             }

        //             returnCategory
        //                 .get(parentCodeCategory)
        //                 ?.subCategory?.set(category.codeCategory, {
        //                     id: category.id,
        //                     level: 2,
        //                     title: category.nameCategory.fr_FR,
        //                     subCategory: new Map(),
        //                     codeCategory: category.codeCategory,
        //                 });
        //             break;
        //         case 3:
        //             const codeCategoryL1 = codes[0];
        //             const codeCategoryL2 = `${codes[0]}.${codes[1]}`;
        //             if (!returnCategory.has(codeCategoryL1)) {
        //                 returnCategory.set(codeCategoryL1, { subCategory: new Map() });
        //             }
        //             if (!returnCategory.get(codeCategoryL1)?.subCategory?.has(codeCategoryL2)) {
        //                 returnCategory
        //                     .get(codeCategoryL1)
        //                     ?.subCategory?.set(codeCategoryL2, { subCategory: new Map() });
        //             }
        //             returnCategory
        //                 .get(codeCategoryL1)
        //                 ?.subCategory?.get(codeCategoryL2)
        //                 ?.subCategory?.set(category.codeCategory, {
        //                     id: category.id,
        //                     level: 3,
        //                     title: category.nameCategory.fr_FR,
        //                     subCategory: new Map(),
        //                     codeCategory: category.codeCategory,
        //                 });
        //             break;
        //         default:
        //             break;
        //     }
        // }

        const findSubCategory = (code: string): Category | undefined => {
            const category = categories.find(
                (cate) => cate.codeCategory === code && cate.linkProduct.length > 0
            );

            if (!category) {
                return undefined;
            }

            categories = categories.filter((cate) => cate.codeCategory !== code);

            if (
                category.categoryLevelCategory === 3 ||
                !category.subcategories ||
                category?.subcategories?.length === 0
            ) {
                return {
                    id: category.id,
                    codeCategory: category.codeCategory,
                    level: category.categoryLevelCategory,
                    title: category.nameCategory.fr_FR,
                    linkProduct: category.linkProduct,
                };
            } else {
                return {
                    id: category.id,
                    codeCategory: category.codeCategory,
                    level: category.categoryLevelCategory,
                    title: category.nameCategory.fr_FR,
                    linkProduct: category.linkProduct,
                    subCategory: category.subcategories
                        ?.map((subCategory: any) => findSubCategory(subCategory.value))
                        .filter((cate: any) => {
                            return cate;
                        }),
                };
            }
        };

        for (const category of categories) {
            if (!category?.categoryLevelCategory || category?.categoryLevelCategory !== 1) {
                continue;
            }
            returnCategory.push({
                id: category.id,
                codeCategory: category.codeCategory,
                level: category.categoryLevelCategory,
                title: category.nameCategory.fr_FR,
                linkProduct: category.linkProduct,
                subCategory: category.subcategories
                    ?.map((subCategory: any) => findSubCategory(subCategory.value))
                    .filter((cate: any) => {
                        return cate;
                    }),
            });
        }
        returnCategory = returnCategory.filter(
            (cate) =>
                cate?.linkProduct?.length! > 0 || (cate.subCategory && cate.subCategory?.length > 0)
        );
        return returnCategory;
    }

    findAllCategoryLevel(level: number): Observable<Category[]> {
        if (!Number.isInteger(level) || level <= 0) {
            return of([]);
        }
        const filterCategories: Filter[] = [
            {
                fieldName: 'statusCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'VALIDE',
                    },
                ],
            },
            {
                fieldName: 'categoryLevelCategory',
                conditions: [...Array(level).keys()].map((lvl) => ({
                    type: 'EQUALS',
                    value: lvl + 1,
                })),
            },
        ];
        return this.dynamicDocumentService
            .find(
                {
                    collectionName: COLLECTION_NAME,
                    filters: filterCategories,
                    page: 1,
                    pageSize: 10000,
                    sorts: {
                        nameCategory: 'ASC',
                    },
                },
                true
            )
            .pipe(
                map((res: any) => {
                    if (!res || !Array.isArray(res.content)) {
                        return [];
                    }
                    return res.content;
                }),
                catchError((error) => {
                    return of([]);
                })
            );
    }

    findOriginal(level = 1, page = 1, pageSize = 999): Observable<Category[]> {
        const filterCategories: Filter[] = [
            {
                fieldName: 'statusCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'VALIDE',
                    },
                ],
            },
            {
                fieldName: 'categoryLevelCategory',
                conditions: [...Array(level).keys()].map((level) => ({
                    type: 'EQUALS',
                    value: level + 1,
                })),
            },
        ];
        return this.dynamicDocumentService.find(
            {
                collectionName: COLLECTION_NAME,
                filters: filterCategories,
                page: page,
                pageSize: pageSize,
                sorts: {
                    nameCategory: 'ASC',
                },
            },
            true,
            false
        );
    }

    transformAll(categories: any[]) {
        let returnCategory: Category[] = [];

        const findSubCategory = (code: string): Category | undefined => {
            const category = categories.find((cate) => cate.codeCategory === code);

            if (!category) {
                return undefined;
            }

            categories = categories.filter((cate) => cate.codeCategory !== code);

            if (
                category.categoryLevelCategory === 3 ||
                !category.subcategories ||
                category?.subcategories?.length === 0
            ) {
                return {
                    id: category.id,
                    codeCategory: category.codeCategory,
                    level: category.categoryLevelCategory,
                    title: category.nameCategory.fr_FR,
                    linkProduct: category.linkProduct,
                };
            } else {
                return {
                    id: category.id,
                    codeCategory: category.codeCategory,
                    level: category.categoryLevelCategory,
                    title: category.nameCategory.fr_FR,
                    linkProduct: category.linkProduct,
                    subCategory: category.subcategories
                        ?.map((subCategory: any) => findSubCategory(subCategory.value))
                        .filter((cate: any) => {
                            return cate;
                        }),
                };
            }
        };

        for (const category of categories) {
            if (!category?.categoryLevelCategory || category?.categoryLevelCategory !== 1) {
                continue;
            }
            returnCategory.push({
                id: category.id,
                codeCategory: category.codeCategory,
                level: category.categoryLevelCategory,
                title: category.nameCategory.fr_FR,
                linkProduct: category.linkProduct,
                subCategory: category.subcategories
                    ?.map((subCategory: any) => findSubCategory(subCategory.value))
                    .filter((cate: any) => {
                        return cate;
                    }),
            });
        }
        return returnCategory;
    }

    transformAllLanguage(categories: any[]) {
        let returnCategory: Category[] = [];

        const findSubCategory = (code: string): Category | undefined => {
            const category = categories.find((cate) => cate.codeCategory === code);

            if (!category) {
                return undefined;
            }

            categories = categories.filter((cate) => cate.codeCategory !== code);

            if (
                category.categoryLevelCategory === 3 ||
                !category.subcategories ||
                category?.subcategories?.length === 0
            ) {
                return {
                    id: category.id,
                    codeCategory: category.codeCategory,
                    level: category.categoryLevelCategory,
                    title: category.nameCategory,
                    linkProduct: category.linkProduct,
                    orderCategory: category?.orderCategory,
                };
            } else {
                return {
                    id: category.id,
                    codeCategory: category.codeCategory,
                    level: category.categoryLevelCategory,
                    title: category.nameCategory,
                    linkProduct: category.linkProduct,
                    orderCategory: category?.orderCategory,
                    subCategory: category.subcategories
                        ?.map((subCategory: any) => findSubCategory(subCategory.value))
                        .filter((cate: any) => {
                            return cate;
                        }),
                };
            }
        };

        for (const category of categories) {
            if (!category?.categoryLevelCategory || category?.categoryLevelCategory !== 1) {
                continue;
            }
            returnCategory.push({
                id: category.id,
                codeCategory: category.codeCategory,
                level: category.categoryLevelCategory,
                title: category.nameCategory,
                linkProduct: category.linkProduct,
                orderCategory: category?.orderCategory,
                subCategory: category.subcategories
                    ?.map((subCategory: any) => findSubCategory(subCategory.value))
                    .filter((cate: any) => {
                        return cate;
                    }),
            });
        }
        return returnCategory;
    }
}
